<template>
  <div class="picture-wrap" v-show="show">
    <div class="picture-template">
      <div class="close" @click="close">
        <i class="el-icon-close"></i>
      </div>
      <div class="title">{{ details.title }}</div>
      <div class="type">
        <span>分类：{{ details.cate_title }}</span>
        <!-- <span>待审核</span> -->
      </div>
      <div class="pics" v-if="details.picurl">
        <video :src="details.picurl" controls class="video"></video>
      </div>
      <div class="tip">
        <div class="brief tlht">{{ details.address }}</div>
        <div class="brief tlht">{{ details.abstract }}</div>
      </div>
      <div class="like" @click="voteAddHandle(details.id)">
        {{ details.like_num }}人喜欢
      </div>
    </div>
  </div>
</template>

<script>
import { voteAdd } from "@/api/index";
export default {
  props: {
    details: {
      type: Object,
      default: {},
    },
    show: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      picIndex: 0,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    voteAddHandle(article_id) {
      voteAdd({
        article_id,
      })
        .then((res) => {
          this.$message.success("投票成功");
          this.details.like_num++;
        })
        .catch((err) => {
          if (err.code == 401) {
            this.$emit("invalid");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.picture-wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.45);

  .picture-template {
    position: relative;
    box-sizing: border-box;
    width: 32rem;
    height: 20rem;
    background: #f6f6f6;
    box-shadow: 0px 6px 28px 1px rgba(111, 144, 131, 0.75);
    padding: 0.8rem 1.2rem;

    .close {
      position: absolute;
      box-sizing: border-box;
      right: 12px;
      top: 12px;
      width: 1rem;
      height: 1rem;
      font-size: 1rem;
      cursor: pointer;
    }

    .title {
      font-size: 0.7466rem;
      color: #3f3f3f;
      line-height: 1.4rem;
      margin-top: 0.5rem;
    }

    .type {
      display: flex;
      justify-content: space-between;
      font-size: 0.5333rem;
      color: #6f6f6f;
      line-height: 0.8rem;
    }

    .pics {
      width: 80%;
      height: 11.2rem;
      margin: 0.5rem auto;

      .video {
        width: 100%;
        height: 100%;
        object-fit: contain;
        background-color: #000;
      }

      /deep/ .el-carousel {
        width: 100%;
        height: 100%;

        .el-carousel__container {
          height: 100%;
        }
      }
    }

    .tip {
      display: flex;
      flex-direction: column;

      .pager {
        width: 2rem;
        font-size: 0.7466rem;
        color: #3f3f3f;
        font-weight: bold;
      }

      .brief {
        flex: 1;
        font-size: 0.5333rem;
        color: #6f6f6f;
        line-height: 0.8rem;
      }
    }

    .like {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 6.66rem;
      height: 1.5rem;
      background: #06BEB6;
      border-radius: 28px;
      font-size: 0.5333rem;
      color: #fff;
      cursor: pointer;
      margin: 0.4rem auto 0;

      img {
        margin-right: 0.4rem;
      }
    }
  }
}
</style>